import type { SVGProps } from "react";

export function IconDarkPurpleRocketLaunch(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      viewBox="0 0 33 33"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M8.9375 20.625L6.0722 23.4903C5.24604 24.3165 4.64406 25.3395 4.32309 26.4629L3.4375 29.5625L6.53705 28.6769C7.66047 28.3559 8.68354 27.754 9.5097 26.9278L12.375 24.0625M11 15.8125L17.1875 22M11 15.8125L17.875 8.9375M11 15.8125H2.75L5.59772 12.9648C8.17635 10.3862 11.6737 8.9375 15.3204 8.9375H17.875M17.1875 22L24.0625 15.125M17.1875 22V26.125V30.25L20.0352 27.4023C22.6138 24.8237 24.0625 21.3263 24.0625 17.6796V15.125M24.0625 15.125L24.8477 14.3398C27.4263 11.7612 28.875 8.26379 28.875 4.61706V4.125H28.3829C24.7362 4.125 21.2388 5.57366 18.6602 8.15228L17.875 8.9375"
        stroke="#3E2247"
        strokeWidth="2.0625"
        strokeLinecap="square"
      />
    </svg>
  );
}
